module.exports = __webpack_public_path__ + "img/black_plus.8e725aed.svg";